import Link from 'next/link';
import { FC } from 'react';

type HousingCardGallerySlideProps = {
  src: string;
  link: string;
  basePath?: string;
  fetchPriority?: 'high' | 'low' | 'auto';
  loading?: 'eager' | 'lazy';
  onLinkClick?: () => void;
};

export const HousingCardGallerySlide: FC<HousingCardGallerySlideProps> = ({
  src,
  link,
  basePath = 'housing',
  fetchPriority,
  loading,
  onLinkClick,
}) => {
  return (
    <Link
      href={`/${basePath}/${link}`}
      style={{ display: 'block', width: '100%', height: '100%' }}
      aria-label="View property"
      onClick={onLinkClick}
    >
      {src && (
        <img
          alt=""
          src={src}
          style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }}
          fetchPriority={fetchPriority}
          loading={loading}
        />
      )}
    </Link>
  );
};
